import React from "react";
import "../../SecuritySchoolsComponents/TabCard.css";
import Link from '@mui/material/Link';

function CloudSecurity() {
  return (
    <>
    <div className="tabCard-content">
    <div className="SSA-row flexCenter">
        <div className="SSA-box">
            <Link to={'/securitySchools'} className="calendar-link">
                <img src="images/SecuritySchools/CloudSecurity/AzureSecurity.png" alt="SSA-img" className="SSA-img" />
                <div className="SSA-box-content">
                    <h3>Azure Security</h3>
                    <p className="comingSoonText">Coming soon!</p>
                    <a href="#" target="_blank">Learn more</a>
                </div>
            </Link>
        </div>
      </div>
    </div>
    </>
  );
}

export default CloudSecurity;
